export const C = {
  bg:"#060810", s1:"#0C0F1A", s2:"#111520", card:"#13172A",
  border:"rgba(255,255,255,0.07)", border2:"rgba(255,255,255,0.13)",
  text:"#E8ECF4", muted:"rgba(255,255,255,0.4)", faint:"rgba(255,255,255,0.06)",
  green:"#00F0A0", blue:"#4DAAFF", amber:"#FFB830", red:"#FF5252",
  purple:"#C084FC", cyan:"#22D4FF", pink:"#F472B6",
};
